import { Grid, NetworkIcon } from 'gu-ui-kit'
import networkIconNamesMap from 'modules/Statistics/networkIconNamesMap'
import PropTypes from 'prop-types'
import React from 'react'

const NetworkRow = ({ label, value }) => {
  return (
    <Grid
      flexAlign={'center'}
      justifyContent={'space-between'}
    >
      {label}
      <NetworkIcon
        name={networkIconNamesMap[value] ?? value}
        size={'m'}
        width={24}
        rounded
      />
    </Grid>
  )
}

NetworkRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
}

const AccountRow = ({ label, network }) => (
  <Grid
    flexAlign={'center'}
    justifyContent={'space-between'}
  >
    {label}
    <NetworkIcon
      name={networkIconNamesMap[network] ?? network}
      size={'m'}
      width={24}
      rounded
    />
  </Grid>
)

AccountRow.propTypes = {
  label: PropTypes.string,
  network: PropTypes.string,
}

export { AccountRow, NetworkRow }
